export default __webpack_public_path__ + "static/media/safari.461ac7a0.png";